module.exports = __webpack_public_path__ + "37c5e1f3b83d53e2e0358311c655f12b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/toast.png
// module id = 3059
// module chunks = 0